import { type ReactNode } from 'react';
import { Box } from '../primitives/Box.js';
import { Stack } from '../primitives/Stack.js';
import { tokens } from '../tokens.js';
import { cx } from '../utils/cx.js';
import styles from './PageRouteScaffold.module.css';

export interface PageRouteScaffoldProps {
  band?: ReactNode;
  bandEnd?: ReactNode;
  children: ReactNode;
  /** Lock page to viewport height — no document vertical scroll; children must flex + paginate. */
  viewportLock?: boolean;
  /** Drop page gutters / vertical inset (Accueil edge-to-edge). Shell padding still applies unless children bleed. */
  flush?: boolean;
}

export function PageRouteScaffold({
  band,
  bandEnd,
  children,
  viewportLock = false,
  flush = false,
}: PageRouteScaffoldProps) {
  // Document overflow is owned by AdminShell / PageShell (100dvh lock).
  // viewportLock only constrains the route column so list pages fill + paginate.

  return (
    <Stack
      gap="xs"
      className={viewportLock ? styles.viewportLock : undefined}
      style={{
        flex: 1,
        minHeight: 0,
        paddingLeft: flush ? 0 : tokens.page.gutterX,
        paddingRight: flush ? 0 : tokens.page.gutterX,
        paddingTop: flush ? 0 : 'var(--wp-space-16)',
        paddingBottom: flush ? 0 : 'var(--wp-space-16)',
      }}
    >
      {band ? (
        <Box className={viewportLock ? styles.viewportLockBand : undefined}>
          <Stack gap="xs">
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
              {band}
              {bandEnd}
            </Box>
          </Stack>
        </Box>
      ) : null}
      <div
        className={cx(styles.contentMax, viewportLock && styles.viewportLockBody)}
        {...(viewportLock ? { 'data-wp-viewport-lock-body': '' } : {})}
      >
        {children}
      </div>
    </Stack>
  );
}
